import { render, staticRenderFns } from "./CreateLanguageFile.vue?vue&type=template&id=6b929ae3&scoped=true&"
import script from "./CreateLanguageFile.vue?vue&type=script&lang=js&"
export * from "./CreateLanguageFile.vue?vue&type=script&lang=js&"
import style0 from "./CreateLanguageFile.vue?vue&type=style&index=0&id=6b929ae3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b929ae3",
  null
  
)

export default component.exports